module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"putCredentialButton.errorMessage":"There was an error encountered while updating the credentials of this cloud connection. If everything looks right please contact support so we can help you :)"}}')
  delete Component.options._Ctor
}
